import { makeStyles } from 'tss-react/mui';

export const useStyles = makeStyles()(({ px, tokens, breakpoints }) => ({
  snackbar: {
    '&&': {
      left: 0,
      right: 0,
      bottom: 0,
      transform: 'none',

      '& .MuiSnackbarContent-message': {
        display: 'flex',
        minWidth: 0,
        flex: 1,
      },
    },
  },

  snackbarHideMessage: {
    '& .MuiSnackbarContent-root': {
      minHeight: 'auto',
    },
    '& .MuiSnackbarContent-message': {
      display: 'none !important',
      flex: '0 0 0',
      width: 0,
      minWidth: 0,
      margin: 0,
      padding: 0,
      position: 'absolute',
    },
    '& .MuiSnackbarContent-action': {
      margin: '0 auto',
      justifyContent: 'center',
      paddingLeft: 0,
      width: '100%',
    },
  },
  snackbarContent: {
    fontSize: tokens.typography.variant.body3.fontSize,
    width: '100%',
    maxWidth: px(840),
    margin: '0 auto',
    borderRadius: 0,
    padding: tokens.spacing['16'],

    background: tokens.colors.bg.dark.primary,
    color: tokens.colors.text.dark.primary,

    '& .MuiSnackbarContent-message': {
      position: 'fixed',
      width: '100%',
      left: 0,
      top: 0,
      background: 'inherit',
      padding: `${tokens.spacing['16']}px`,
    },

    '& .MuiSnackbarContent-action': {
      margin: 0,
      width: '100%',
      justifyContent: 'center',
    },

    [breakpoints.up('sm')]: {
      fontSize: tokens.typography.variant.body2.fontSize,
      padding: `${tokens.spacing['12']}px ${tokens.spacing['48']}px`,
      flexWrap: 'wrap',

      '& .MuiSnackbarContent-message': {
        width: 'unset',
        marginBottom: 'unset',
        position: 'unset',
        padding: 'unset',
      },

      '& .MuiSnackbarContent-action': {
        width: 'unset',
        marginBottom: 'unset',
        marginLeft: 'auto',
        paddingLeft: tokens.spacing['24'],
        marginRight: 0,
      },
    },

    [breakpoints.up('md')]: {
      width: px(840),
      margin: `0 auto ${tokens.spacing['24']}px`,
      borderRadius: tokens.radius.l,
      paddingTop: tokens.spacing['16'],
      paddingRight: tokens.spacing['16'],
      paddingBottom: tokens.spacing['16'],
      paddingLeft: tokens.spacing['24'],
    },
  },
  snackbarContentSticky: {
    width: '100%',
    margin: '0 auto',
    borderRadius: 0,
    padding: `${tokens.spacing['16']}px`,
    background: tokens.colors.bg.dark.primary,
    color: tokens.colors.text.dark.primary,
    [breakpoints.up('sm')]: {
      '& .MuiSnackbarContent-action': {
        paddingLeft: tokens.spacing['24'],
      },
    },
    [breakpoints.up('xs')]: {
      '& .MuiSnackbarContent-action': {
        marginRight: 0,
      },
    },
  },
  snackbarContentPositionTop: {
    position: 'fixed',
    top: 0,
    width: '100%',
    borderRadius: 0,
    padding: `${tokens.spacing['16']}px`,
    background: tokens.colors.bg.dark.primary,
    color: tokens.colors.text.dark.primary,
  },
}));
